/**
 * state extension for store module
 */
export var state = {
    providers: {},
    heartbeats: {} // registry for all heartbeats
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/store/state.ts
// module id = null
// module chunks = 